import React, { useMemo } from "react";
import dayjs from "dayjs";
import Modal from "../../Modal/Modal";
import TableAdv from "../../Table/TableAdv/TableAdv";
import SmartTooltip from "../../Info/SmartTooltip";
import { toTitleCase } from "../../../utils/common";
import { formatWords2 } from "../../../utils/stringUtils";
import LogoLoader from "../../Loading/LogoLoader";
import Backdrop from "../../Backgrounds/Backdrop";


export default function RootJobsModal({ isOpen, onClose, data, totalCount, page,
  limit,
  setPage,
  handleLimitChange, type, loading }) {

  const rows = useMemo(() => {
    const list = Array.isArray(data) ? data : [];
    return list
      .map((job) => {
        const addedOn = job?.addedOn
          ? dayjs(job.addedOn).format("MMM DD, YYYY")
          : "";

        const bdmName = `${job?.addedBy?.firstName || ""} ${job?.addedBy?.lastName || ""
          }`.trim();

        return {
          jobId: job?.uiid ?? "",
          jobTitle: toTitleCase(job?.jobTitle) ?? "",
          companyName: toTitleCase(job?.companyName) ?? "",
          addedOn,
          bdmName: toTitleCase(bdmName),
        };
      })
      .sort((a, b) => {
        const at = dayjs(a.addedOn).valueOf() || 0;
        const bt = dayjs(b.addedOn).valueOf() || 0;

        if (bt !== at) return bt - at;
        return String(a.jobTitle || "").localeCompare(String(b.jobTitle || ""));
      });
  }, [data]);

  const columns = useMemo(
    () => [
      {
        key: "jobTitle",
        label: "Job Title",
        width: "min-w-[260px]! max-w-[340px]!",
        render: (row) => (
          <SmartTooltip
            description={formatWords2(row?.jobTitle)}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{formatWords2(row?.jobTitle)}</div>
          </SmartTooltip>
        ),
      },
      {
        key: "companyName",
        label: "Company",
        width: "min-w-[220px]! max-w-[280px]!",
        render: (row) => (
          <SmartTooltip
            description={formatWords2(row?.companyName)}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{formatWords2(row?.companyName)}</div>
          </SmartTooltip>
        ),
      },
      {
        key: "addedOn",
        label: "Job Open Date",
        width: "min-w-[160px]!",
      },
      {
        key: "bdmName",
        label: type == "recruit" ? "Recruiter Name" : "BDM Name",
        width: "min-w-[220px]! max-w-[280px]!",
        render: (row) => (
          <SmartTooltip
            description={formatWords2(row?.bdmName)}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{formatWords2(row?.bdmName)}</div>
          </SmartTooltip>
        ),
      },
    ],
    [],
  );


  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Jobs List"
      width="max-w-5xl"
      bodyClassName="p-0.5 flex-1 overflow-auto"
    >
      <div className="w-full max-h-[70vh] overflow-hidden p-2 flex flex-1 ">
        <TableAdv
          showSlNo
          columns={columns}
          rows={rows}
          tableId="treeHierarchyRootJobs"
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
            filter: false,
            download: false,
            viewToggle: false,
            fullScreen: false,
            add: [],
          }}
          toolbarLeft={{ add: [] }}
        />
        <Backdrop isOpen={loading} zIndex={5}>
            <LogoLoader />
          </Backdrop>
      </div>
    </Modal>
  );
}
